/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteRemoteSessionIssuerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteRemoteSessionIssuerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteRemoteSessionIssuerSecurity = {
  option1?: DeleteRemoteSessionIssuerSecurityOption1 | undefined;
  option2?: DeleteRemoteSessionIssuerSecurityOption2 | undefined;
};

export type DeleteRemoteSessionIssuerRequest = {
  /**
   * The remote_session_issuer id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteRemoteSessionIssuerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteRemoteSessionIssuerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DeleteRemoteSessionIssuerSecurityOption1$Outbound,
    DeleteRemoteSessionIssuerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteRemoteSessionIssuerSecurityOption1ToJSON(
  deleteRemoteSessionIssuerSecurityOption1:
    DeleteRemoteSessionIssuerSecurityOption1,
): string {
  return JSON.stringify(
    DeleteRemoteSessionIssuerSecurityOption1$outboundSchema.parse(
      deleteRemoteSessionIssuerSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteRemoteSessionIssuerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteRemoteSessionIssuerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DeleteRemoteSessionIssuerSecurityOption2$Outbound,
    DeleteRemoteSessionIssuerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function deleteRemoteSessionIssuerSecurityOption2ToJSON(
  deleteRemoteSessionIssuerSecurityOption2:
    DeleteRemoteSessionIssuerSecurityOption2,
): string {
  return JSON.stringify(
    DeleteRemoteSessionIssuerSecurityOption2$outboundSchema.parse(
      deleteRemoteSessionIssuerSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteRemoteSessionIssuerSecurity$Outbound = {
  Option1?: DeleteRemoteSessionIssuerSecurityOption1$Outbound | undefined;
  Option2?: DeleteRemoteSessionIssuerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteRemoteSessionIssuerSecurity$outboundSchema: z.ZodMiniType<
  DeleteRemoteSessionIssuerSecurity$Outbound,
  DeleteRemoteSessionIssuerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteRemoteSessionIssuerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteRemoteSessionIssuerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteRemoteSessionIssuerSecurityToJSON(
  deleteRemoteSessionIssuerSecurity: DeleteRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    DeleteRemoteSessionIssuerSecurity$outboundSchema.parse(
      deleteRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type DeleteRemoteSessionIssuerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteRemoteSessionIssuerRequest$outboundSchema: z.ZodMiniType<
  DeleteRemoteSessionIssuerRequest$Outbound,
  DeleteRemoteSessionIssuerRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteRemoteSessionIssuerRequestToJSON(
  deleteRemoteSessionIssuerRequest: DeleteRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    DeleteRemoteSessionIssuerRequest$outboundSchema.parse(
      deleteRemoteSessionIssuerRequest,
    ),
  );
}
